import { lazy } from "react";
import VILLES from "@/data/villes";

/**
 * Routes AOT (Autorisation d'Occupation Temporaire / stationnement déménagement).
 * - Hub principal + 7 hubs départementaux
 * - Pages dédiées Paris et Antony
 * - Pages template éditorialisées (AOT_TEMPLATE_SLUGS)
 * - Fallback générique pour toutes les autres villes de villes-aot-data
 */

const AutorisationStationnement = lazy(() => import("@/pages/AutorisationStationnement"));
const AutorisationStationnementVille = lazy(() => import("@/pages/AutorisationStationnementVille"));
const AutorisationStationnementParis = lazy(() => import("@/pages/AutorisationStationnementParis"));
const AutorisationStationnementAntony = lazy(() => import("@/pages/AutorisationStationnementAntony"));
const AutorisationVilleTemplate = lazy(() => import("@/pages/AutorisationVilleTemplate"));
const AotYvelines78 = lazy(() => import("@/pages/AotYvelines78"));
const AotHautsDeSeine92 = lazy(() => import("@/pages/AotHautsDeSeine92"));
const AotValDeMarne94 = lazy(() => import("@/pages/AotValDeMarne94"));
const AotSeineSaintDenis93 = lazy(() => import("@/pages/AotSeineSaintDenis93"));
const AotSeineEtMarne77 = lazy(() => import("@/pages/AotSeineEtMarne77"));
const AotEssonne91 = lazy(() => import("@/pages/AotEssonne91"));
const AotValDoise95 = lazy(() => import("@/pages/AotValDoise95"));

export const AOT_TEMPLATE_SLUGS = [
  "vaux-le-penil",
  "lesigny",
  "courtry",
  "vert-saint-denis",
  "cesson",
  "asnieres-sur-seine",
  "bagneux",
  "bois-colombes",
  "boulogne-billancourt",
  "bourg-la-reine",
  "chatenay-malabry",
  "chatillon",
  "chaville",
  "ablon-sur-seine",
  "clamart",
  "clichy",
  "colombes",
  "alfortville",
  "arcueil",
  "boissy-saint-leger",
  "bonneuil-sur-marne",
  "bry-sur-marne",
  "cachan",
  "champigny-sur-marne",
  "charenton-le-pont",
  "chennevieres-sur-marne",
  "chevilly-larue",
  "choisy-le-roi",
  "courbevoie",
  "fontenay-aux-roses",
  "garches",
  "gennevilliers",
  "issy-les-moulineaux",
  "la-garenne-colombes",
  "le-plessis-robinson",
  "levallois-perret",
  "malakoff",
  "marnes-la-coquette",
  "meudon",
  "montrouge",
  "nanterre",
  "neuilly-sur-seine",
  "puteaux",
  "rueil-malmaison",
  "saint-cloud",
  "sceaux",
  "sevres",
  "suresnes",
  "vanves",
  "vaucresson",
  "ville-d-avray",
  "villeneuve-la-garenne",
  "creteil",
  "fontenay-sous-bois",
  "fresnes",
  "gentilly",
  "ivry-sur-seine",
  "joinville-le-pont",
  "l-hay-les-roses",
  "la-queue-en-brie",
  "le-kremlin-bicetre",
  "le-perreux-sur-marne",
  "le-plessis-trevise",
  "limeil-brevannes",
  "maisons-alfort",
  "mandres-les-roses",
  "marolles-en-brie",
  "nogent-sur-marne",
  "noiseau",
  "orly",
  "ormesson-sur-marne",
  "perigny",
  "rungis",
  "saint-mande",
  "saint-maur-des-fosses",
  "saint-maurice",
  "santeny",
  "sucy-en-brie",
  "thiais",
  "valenton",
  "villecresnes",
  "villejuif",
  "villeneuve-le-roi",
  "villeneuve-saint-georges",
  "villiers-sur-marne",
  "vincennes",
  "vitry-sur-seine",
  // Yvelines (78) — 64 villes
  "acheres",
  "aigremont",
  "andelu",
  "andresy",
  "aubergenville",
  "auffargis",
  "bailly",
  "bazemont",
  "bazoches-sur-guyonne",
  "bois-d-arcy",
  "bougival",
  "buc",
  "carrieres-sous-poissy",
  "carrieres-sur-seine",
  "chambourcy",
  "chanteloup-les-vignes",
  "chatou",
  "chateaufort",
  "chavenay",
  "chevreuse",
  "coignieres",
  "conflans-sainte-honorine",
  "crespieres",
  "croissy-sur-seine",
  "davron",
  "elancourt",
  "etang-la-ville",
  "l-etang-la-ville",
  "feucherolles",
  "fontenay-le-fleury",
  "fourqueux",
  "gargenville",
  "guyancourt",
  "herbeville",
  "houilles",
  "issou",
  "jouy-en-josas",
  "juziers",
  "la-celle-saint-cloud",
  "la-verriere",
  "le-chesnay-rocquencourt",
  "le-mesnil-le-roi",
  "le-pecq",
  "le-port-marly",
  "le-vesinet",
  "les-alluets-le-roi",
  "les-clayes-sous-bois",
  "les-loges-en-josas",
  "les-mesnuls",
  "les-mureaux",
  "limay",
  "louveciennes",
  "magnanville",
  "maisons-laffitte",
  "mantes-la-jolie",
  "mantes-la-ville",
  "mareil-marly",
  "mareil-sur-mauldre",
  "marly-le-roi",
  "maurecourt",
  "maurepas",
  "meulan-en-yvelines",
  "montesson",
  "montigny-le-bretonneux",
  "morainvilliers",
  "noisy-le-roi",
  "orgeval",
  "plaisir",
  "poissy",
  "rambouillet",
  "rennemoulin",
  "saint-cyr-l-ecole",
  "saint-germain-en-laye",
  "saint-nom-la-breteche",
  "sartrouville",
  "toussus-le-noble",
  "trappes",
  "triel-sur-seine",
  "velizy-villacoublay",
  "verneuil-sur-seine",
  "vernouillet",
  "versailles",
  "villennes-sur-seine",
  "villepreux",
  "viroflay",
  // Seine-Saint-Denis (93)
  "aubervilliers",
  "avon",
  "bailly-romainvilliers",
  "bois-le-roi",
  "brie-comte-robert",
  "brou-sur-chantereine",
  "bussy-saint-georges",
  "bussy-saint-martin",
  "chailly-en-biere",
  "champs-sur-marne",
  "chelles",
  "chessy",
  "claye-souilly",
  "combs-la-ville",
  "coulommiers",
  "coupvray",
  "cregy-les-meaux",
  "crouy-sur-ourcq",
  "dammarie-les-lys",
  "dammartin-en-goele",
  "donnemarie-dontilly",
  "emerainville",
  "esbly",
  "gretz-armainvilliers",
  "guignes",
  "jouarre",
  "la-ferte-sous-jouarre",
  "lagny-sur-marne",
  "le-mee-sur-seine",
  "lizy-sur-ourcq",
  "magny-le-hongre",
  "meaux",
  "melun",
  "mitry-mory",
  "moissy-cramayel",
  "montereau-fault-yonne",
  "lieusaint",
  "lognes",
  "montevrain",
  "moret-loing-et-orvanne",
  "mouroux",
  "nangis",
  "nanteuil-les-meaux",
  "nemours",
  "noisiel",
  "othis",
  "villenoy",
  "villeparisis",
  "vernou-la-celle-sur-seine",
  "vaires-sur-marne",
  "ury",
  "ozoir-la-ferriere",
  "perthes",
  "pontault-combault",
  "precy-sur-marne",
  "provins",
  "rebais",
  "roissy-en-brie",
  "rozay-en-brie",
  "saint-fargeau-ponthierry",
  "saint-germain-sur-morin",
  "saint-soupplets",
  "saint-thibault-des-vignes",
  "samois-sur-seine",
  "samoreau",
  "savigny-le-temple",
  "serris",
  "thorigny-sur-marne",
  "torcy",
  "tournan-en-brie",
  "trilport",
  "faremoutiers",
  "fontainebleau",
  "aulnay-sous-bois",
  "bagnolet",
  "le-blanc-mesnil",
  "bobigny",
  "bondy",
  "le-bourget",
  "clichy-sous-bois",
  "coubron",
  "la-courneuve",
  "drancy",
  "dugny",
  "epinay-sur-seine",
  "gagny",
  "gournay-sur-marne",
  "l-ile-saint-denis",
  "les-lilas",
  "livry-gargan",
  "montfermeil",
  "montreuil",
  "neuilly-plaisance",
  "neuilly-sur-marne",
  "noisy-le-grand",
  "noisy-le-sec",
  "pantin",
  "les-pavillons-sous-bois",
  "le-pre-saint-gervais",
  "le-raincy",
  "romainville",
  "saint-denis",
  "rosny-sous-bois",
  "saint-ouen-sur-seine",
  "sevran",
  "stains",
  "pierrefitte-sur-seine",
  "villetaneuse",
  "tremblay-en-france",
  "vaujours",
  "villemomble",
  "villepinte",

  // Val-d'Oise (95)
  "argenteuil",
  "bezons",
  "cormeilles-en-parisis",
  "montigny-les-cormeilles",
  "cergy",
  "osny",
  "vaureal",
  "jouy-le-moutier",
  "eragny",
  "sarcelles",
  "garges-les-gonesse",
  "villiers-le-bel",
  "deuil-la-barre",
  "saint-brice-sous-foret",
  "goussainville",
  "gonesse",
  "louvres",
  "fosses",
  "roissy-en-france",
  "franconville",
  "ermont",
  "eaubonne",
  "taverny",
  "bessancourt",
  "montmorency",
  "saint-gratien",
  "soisy-sous-montmorency",
  "enghien-les-bains",
  "domont",
  "l-isle-adam",
  "persan",
  "beaumont-sur-oise",
  "mery-sur-oise",
  "viarmes",
  "saint-ouen-l-aumone",
  "pontoise",
  "herblay-sur-seine",
  "beauchamp",
  "saint-leu-la-foret",
  "sannois",

  // Essonne (91)
  "evry-courcouronnes",
  "corbeil-essonnes",
  "massy",
  "savigny-sur-orge",
  "sainte-genevieve-des-bois",
  "vigneux-sur-seine",
  "bretigny-sur-orge",
  "marolles-en-hurepoix",
  "vert-le-grand",
  "vert-le-petit",
  "saint-vrain",
  "itteville",
  "la-ferte-alais",
  "cerny",
  "guigneville-sur-essonne",
  "boutigny-sur-essonne",
  "maisse",
  "gironville-sur-essonne",
  "buno-bonnevaux",
  "boigneville",
  "prunay-sur-essonne",
  "champmotteux",
  "blandy",
  "brouy",
  "mespuits",
  "palaiseau",
  "athis-mons",
  "ris-orangis",
  "viry-chatillon",
  "draveil",
  "yerres",
  "les-ulis",
  "brunoy",
  "montgeron",
  "gif-sur-yvette",
  "longjumeau",
  "saint-michel-sur-orge",
  "etampes",
  "grigny",
  "juvisy-sur-orge",
];

export const AOT_ROUTES = [
  // Hub principal + hubs départementaux
  { path: "/autorisation-de-stationnement-demenagement", Component: AutorisationStationnement },
  { path: "/aot-yvelines-78", Component: AotYvelines78 },
  { path: "/aot-hauts-de-seine-92", Component: AotHautsDeSeine92 },
  { path: "/aot-val-de-marne-94", Component: AotValDeMarne94 },
  { path: "/aot-seine-saint-denis-93", Component: AotSeineSaintDenis93 },
  { path: "/aot-seine-et-marne-77", Component: AotSeineEtMarne77 },
  { path: "/aot-essonne-91", Component: AotEssonne91 },
  { path: "/aot-val-d-oise-95", Component: AotValDoise95 },
  // Pages dédiées
  { path: "/autorisation-de-stationnement-demenagement-paris", Component: AutorisationStationnementParis },
  { path: "/autorisation-de-stationnement-demenagement-antony", Component: AutorisationStationnementAntony },
  // Pages template éditorialisées
  ...AOT_TEMPLATE_SLUGS.map((s) => ({
    path: `/autorisation-de-stationnement-demenagement-${s}`,
    Component: AutorisationVilleTemplate,
  })),
  // Fallback générique pour le reste des villes de villes-aot-data
  ...VILLES.filter(
    (v) => v.slug !== "paris" && v.slug !== "antony" && !AOT_TEMPLATE_SLUGS.includes(v.slug),
  ).map((v) => ({
    path: `/autorisation-de-stationnement-demenagement-${v.slug}`,
    Component: AutorisationStationnementVille,
  })),
];
